export default __webpack_public_path__ + "static/renner_500_medium-webfont-8e068cb101a620d16498a773d851815d.woff2";